import React, { useEffect } from "react";
import {
  Bell,
  User,
  LogOut,
  Menu,
  Search
} from "lucide-react";

import { useDispatch, useSelector } from "react-redux";
import { logoutMerchant } from "../../../features/merchant/merchantThunks";
import { fetchNotifications } from "../../../features/notifications/notificationThunks";
import { toast } from "react-toastify";
import { navigateTo } from "../../../utils/navigation";

const Header = ({ onMenuClick }) => {
  const dispatch = useDispatch();

  // 🔔 GET UNREAD COUNT FROM REDUX
  const unreadCount = useSelector(
    (state) => state.notifications.unreadCount
  );

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  const handleLogout = async () => {
    await dispatch(logoutMerchant());
    toast.success("Logged out successfully!");
    navigateTo("/merchant-login");
  };

  const handleRedirect = async () => {
    navigateTo("/dashboard/merchant-profile");
  };

  const openNotifications = () => {
    navigateTo("/dashboard/notifications");
  };

  return (
    <header className="custom-header">
      <div className="header-left">
        <button className="menu-toggle" onClick={onMenuClick}>
          <Menu size={24} />
        </button>

        <h1 className="header-title">Dashboard</h1>
        <h1 className="mobile-title">Dashboard</h1>
      </div>

      <div className="header-actions ms-3">

        {/* 🔔 NOTIFICATION BUTTON */}
        <button
          className="header-action-btn"
          onClick={openNotifications}
        >
          <Bell size={20} />
          {unreadCount > 0 && (
            <span className="notification-badge">
              {unreadCount}
            </span>
          )}
        </button>

       <button className="header-action-btn" onClick={handleRedirect}>
          <User size={20} />
        </button>

        <button
          className="header-action-btn logout"
          onClick={handleLogout}
        >
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
};

export default Header;
